import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["key", "icon", "title"],
    _excluded2 = ["footerMenus", "logo", "onClose", "visible"];

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import { Drawer } from 'antd';
import { identity } from 'lodash-es';
import styled from 'styled-components';
import Menu from './Menu';
var SidebarMenu = styled(Menu)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-menu {\n    padding-top: 0.571rem;\n    padding-bottom: 1.714rem;\n  }\n"])));
var SidebarMenuItem = styled(Menu.Item)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &.ant-menu-item {\n    height: 2.714rem;\n    line-height: 2.714rem;\n\n    &:not(:last-child) {\n      margin-bottom: 0;\n    }\n  }\n"])));
var Logo = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 50%;\n"])));
/**
 * Sidebar footer menu
 * @param {Object[]} menus menu items to be rendered, written as an object of antd Menu.Item props
 * @returns {ReactNode}
 */

var Footer = function Footer(_ref) {
  var _ref$menus = _ref.menus,
      menus = _ref$menus === void 0 ? [] : _ref$menus;
  return /*#__PURE__*/React.createElement(SidebarMenu, {
    selectable: false
  }, menus.map(function (_ref2) {
    var key = _ref2.key,
        icon = _ref2.icon,
        title = _ref2.title,
        menuProps = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/React.createElement(SidebarMenuItem, _extends({
      key: key,
      icon: icon
    }, menuProps), title);
  }));
};
/**
 * Sidebar for mobile page
 *
 * @param {Object[]} footerMenus menu items to be rendered at footer section,
 * written as an object of antd Menu.Item props
 * @param {String} logo logo source
 * @param {Function} onClose callback function to be called when the sidebar is closed
 * @param {Boolean} visible whether the sidebar is visible or not
 * Other props will be directly passed into antd Drawer component
 *
 * @returns {ReactNode}
 */


var SidebarMobile = function SidebarMobile(_ref3) {
  var _ref3$footerMenus = _ref3.footerMenus,
      footerMenus = _ref3$footerMenus === void 0 ? [] : _ref3$footerMenus,
      _ref3$logo = _ref3.logo,
      logo = _ref3$logo === void 0 ? null : _ref3$logo,
      _ref3$onClose = _ref3.onClose,
      onClose = _ref3$onClose === void 0 ? identity : _ref3$onClose,
      _ref3$visible = _ref3.visible,
      visible = _ref3$visible === void 0 ? false : _ref3$visible,
      drawerProps = _objectWithoutProperties(_ref3, _excluded2);

  var logoImage = logo && /*#__PURE__*/React.createElement(Logo, {
    src: logo,
    alt: "logo"
  });
  var footer = (footerMenus === null || footerMenus === void 0 ? void 0 : footerMenus.length) && /*#__PURE__*/React.createElement(Footer, {
    menus: footerMenus
  });
  return /*#__PURE__*/React.createElement(Drawer, _extends({
    closable: false,
    footer: footer,
    footerStyle: {
      padding: 0
    },
    headerStyle: {
      padding: '1.143rem'
    },
    onClose: onClose,
    placement: "left",
    title: logoImage,
    visible: visible
  }, drawerProps));
};

export default SidebarMobile;